import React from "react";
import { toast } from "react-toastify";
import { useQuery, useSave, useSet } from "seed/gql";
import { SAVE_CHAT_MEMORY, SET_CHAT_MEMORY } from "seed/gql/queries";
import { useAuth } from "components/util/helpers/providers/AuthProvider";
import l from "components/util/l";
import View from "components/tmisc/chat/rules/Rules.view";

const onSaveError = () => toast(l("No se pudo guardar la regla%CH043"), { type: "error" });

const Rules = ({
  flow,
  nodeId, // The agent this chat slot runs, when it runs one
  onClose,
}) => {

  const user = useAuth();

  // Every row for this person in this project: the project-level one (node is null)
  // and, when this chat runs an agent, that agent's own on top of it.
  const reqMemory = useQuery(`{
    chatMemories {
      id
      content
      node {
        id
      }
    }
  }`, (flow?.id && user?.id) ? `flow.id=${flow.id} AND user.id=${user.id}` : null,
    { skip: !flow?.id || !user?.id });

  const [callSet, setState] = useSet(SET_CHAT_MEMORY, { onCompleted: reqMemory.refetch, onError: onSaveError });
  const [callSave, saveState] = useSave(SAVE_CHAT_MEMORY, { onCompleted: reqMemory.refetch, onError: onSaveError });

  const rows = reqMemory.data?.chatMemories || [];
  const projectRow = rows.find(row => !row.node) || null;
  const nodeRow = nodeId ? (rows.find(row => row.node?.id == nodeId) || null) : null;

  // Only the "rules" key is ever touched, so a save here never wipes out whatever
  // else an agent already wrote into the same row through its own memory tool.
  const saveRules = (row, owner, rules) => {
    const content = { ...(row?.content || {}), rules };
    if (row) callSet({ id: row.id, content });
    else callSave({ content, ...owner });
  };

  const onSaveProjectRules = (rules) => saveRules(projectRow, { flow: flow.id, user: user.id }, rules);
  const onSaveNodeRules = (rules) => saveRules(nodeRow, { flow: flow.id, user: user.id, node: nodeId }, rules);

  return <View
    isLoading={reqMemory.loading}
    isSaving={setState.loading || saveState.loading}
    nodeId={nodeId}
    nodeRules={nodeRow?.content?.rules || []}
    projectRules={projectRow?.content?.rules || []}
    onClose={onClose}
    onSaveNodeRules={onSaveNodeRules}
    onSaveProjectRules={onSaveProjectRules}
  />;

};

export default Rules;
